<template>
  <div :class="{ label: label }" class="countdown">
    <!-- 일 단위 시간 표시 -->
    <div class="time">
      <p class="num">
        {{ days }}<span v-if="!label">일</span>
      </p>
      <p v-if="label" class="label">일</p>
    </div>

    <!-- label 모드일 때만 콜론 표시 -->
    <div v-if="label" class="colon"></div>

    <!-- 시 단위 시간 표시 -->
    <div class="time">
      <p class="num">{{ hours }}</p>
      <p v-if="label" class="label">시간</p>
    </div>

    <div class="colon"></div>

    <!-- 분 단위 시간 표시 -->
    <div class="time">
      <p class="num">{{ minutes }}</p>
      <p v-if="label" class="label">분</p>
    </div>

    <div class="colon"></div>

    <!-- 초 단위 시간 표시 -->
    <div class="time">
      <p class="num second">{{ seconds }}</p>
      <p v-if="label" class="label">초</p>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'CountDown',
  props: [
    'endDate', // 종료 시간(날짜 문자열 혹은 Date 객체)
    'label'    // label 모드 여부 (bool), true면 시간 단위가 별도로 분리되어 표시됨
  ],
  data() {
    return {
      days: null,
      hours: null,
      minutes: null,
      seconds: null,
      isEnded: null // 종료 여부 플래그
    };
  },
  mounted() {
    // 컴포넌트 마운트 시 tick 함수 호출 및 1초마다 tick 반복 실행
    this.tick();
    this.timer = setInterval(this.tick.bind(this), 1000);
  },
  beforeDestroy() {
    // 컴포넌트 파괴 시 타이머 정리
    clearInterval(this.timer);
  },
  methods: {
    // 남은 시간(밀리초)을 받아서 일, 시, 분, 초로 계산해서 업데이트
    updateRemaining(distance) {
      function getDigit(num) {
        // 두 자리 숫자 포맷으로 변환 (예: 02, 09)
        return `${('0' + num).slice(-2)}`;
      }

      this.days = getDigit(Math.floor(distance / (1000 * 60 * 60 * 24)));
      this.hours = getDigit(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
      this.minutes = getDigit(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
      this.seconds = getDigit(Math.floor((distance % (1000 * 60)) / 1000));
    },

    // 1초마다 호출되는 함수: 현재시간과 종료시간 차이 계산해서 남은 시간 업데이트
    tick() {
      const currentTime = dayjs().valueOf();        // 현재 시간 밀리초
      const endDate = dayjs(this.endDate).valueOf(); // 종료 시간 밀리초

      // 남은 시간 계산, 음수일 경우 0으로 대체
      const distance = Math.max(endDate - currentTime, 0);

      this.updateRemaining(distance);

      // 남은 시간이 0이 되면 타이머 제거, 종료 상태 설정
      if (distance === 0) {
        clearInterval(this.timer);
        this.isEnded = true;
      }
    }
  }
}
</script>
